import { Component, OnInit } from '@angular/core'
import { ProductService } from './product.service'
import { ProductModel } from './product.model'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-product.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './product.master.component.html',
  styleUrl: './product.master.component.css',
})
export class ProductMasterComponent {
  productColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'productName',
      displayName: 'Product Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    public masterCommonService: MasterCommonServices,
    private productService: ProductService,
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) {}

  openAddUpdateProductDialog(mode: string, product?: ProductModel): void {
    const fields = this.productColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: product || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updateProduct(result)
        } else {
          this.addProduct(result)
        }
      }
    })
  }

  addProduct(product: ProductModel): void {
    this.productService.addProduct(product).subscribe({
      next: () => {
        this.toastr.success('Product Added Successfully!', 'Success')
        this.masterCommonService.getAllProducts()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updateProduct(product: any): void {
    this.productService.updateProduct(product).subscribe({
      next: () => {
        this.toastr.success('Product Updated Successfully!', 'Success')
        this.masterCommonService.getAllProducts()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deleteProduct(product: ProductModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this product?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        product.isDeleted = true
        this.productService.deleteProduct(product).subscribe({
          next: () => {
            this.masterCommonService.productsList = this.masterCommonService.productsList.filter(
              (p) => p.id !== product.id,
            )
            this.toastr.success('Product Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
